import {
    Box,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    Grid
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../providers/app-context-provider/app.context";
import dataProvider from '../../../../providers/data-provider';
import { DashboardFilters } from "./dashboard-filters";
import { QualitativeDashboard } from "./qualitative-dashboard";
import { QuantitativeDashboard } from "./quantitative-dashboard";
import { dashboardStyles } from "./styles";

const ViewMode = Object.freeze({
    QUANTITATIVE: 'QUANTITATIVE', QUALITATIVE: 'QUALITATIVE'
})

export const SchoolManagerDashboard = () => {

    const context = useContext(AppContext)
    const profile = context.profile.name

    const [filters, setFilters] = useState({});

    const classes = dashboardStyles();

    const [quantitativeData, setQuantitativeData] = useState(null);
    const [qualitativeData, setQualitativeData] = useState(null);
    const [viewMode, setViewMode] = useState(ViewMode.QUANTITATIVE);
    const [loading, setLoading] = useState(false)

    const fetchQualitativeDashboard = async (data) => {
        return await dataProvider.get('manager-dashboard', 'qualitative', data)
    }

    const fetchQuantitativeDashboard = async (data) => {
        return await dataProvider.get('manager-dashboard', 'quantitative', data)
    }

    useEffect(() => {
        const reload = async () => {
            setLoading(true);

            const effectiveFilters = {}
            Object.keys(filters).forEach((item) => {
                if (filters[item]) {
                    effectiveFilters[item] = filters[item]
                }
            })

            try {
                if (viewMode === ViewMode.QUANTITATIVE) {
                    const response = await fetchQuantitativeDashboard(effectiveFilters);
                    setQuantitativeData(response.data);
                    setQualitativeData(null)
                } else {
                    const response = await fetchQualitativeDashboard(effectiveFilters);
                    setQualitativeData(response.data);
                    setQuantitativeData(null)
                }
            } finally {
                setLoading(false);
            }
        };
        reload();
    }, [filters]);

    const loadQuantitativeDashboard = async () => {
        if (quantitativeData) { return; }
        setLoading(true);
        try {
            const response = await fetchQuantitativeDashboard(filters)
            setQuantitativeData(response.data);
        } finally {
            setLoading(false);
        }
    };

    const loadQualitativeDashboard = async () => {
        if (qualitativeData) { return; }
        setLoading(true);
        try {
            const response = await fetchQualitativeDashboard(filters)
            setQualitativeData(response.data);

        } finally {
            setLoading(false);
        }
    };

    const handleViewModeChange = (nextMode) => {
        setViewMode(nextMode);
    };

    useEffect(() => {
        const loadData = async () => {
            if (viewMode === ViewMode.QUANTITATIVE) {
                await loadQuantitativeDashboard();
            } else if (viewMode === ViewMode.QUALITATIVE) {
                await loadQualitativeDashboard();
            }
        }
        loadData()
    }, [viewMode])

    return (
        <Box className={classes.root}>
            <Card className={classes.filtersCard}>
                <CardContent>
                    <Grid container xs={12} className={classes.dashboardSelector}>
                        <Grid item xs={12} alignContent="center">
                            <ButtonGroup fullWidth>
                                <Button
                                    variant={viewMode === ViewMode.QUANTITATIVE ? "contained" : "outlined"}
                                    color="primary"
                                    onClick={() => handleViewModeChange(ViewMode.QUANTITATIVE)}
                                >
                                    {`Quantitativo`}
                                </Button>
                                <Button
                                    variant={viewMode === ViewMode.QUALITATIVE ? "contained" : "outlined"}
                                    color="primary"
                                    onClick={() => handleViewModeChange(ViewMode.QUALITATIVE)}
                                >
                                    {`Qualitativo`}
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item container xs={12}>
                            <DashboardFilters
                                profile={profile} filters={filters} setFilters={setFilters}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {viewMode === ViewMode.QUANTITATIVE && quantitativeData && (
                <QuantitativeDashboard
                    data={quantitativeData}
                />
            )}
            {viewMode === ViewMode.QUALITATIVE && qualitativeData && (
                <QualitativeDashboard
                    data={qualitativeData}
                />
            )}
        </Box>
    )
}